<template>
  <ContentWrapper>
    <main id="main" class="main pt-32 pb-20 tablet-landscape:pb-24 laptop:pb-30">
      <div class="text-center text-2xl font-headings my-12 font-bold">
        Privacy Policy
      </div>
      <div class="blocks space-y-20 tablet-landscape:space-y-24 laptop:space-y-30">
        <section class="section accordions-block">
          <div
            class="mx-auto w-full max-w-2xl"
          >
            <div
              class="grid grid-cols-4 gap-4 gap-y-6 tablet:grid-cols-8 tablet:gap-6 tablet-landscape:grid-cols-12 laptop:gap-8"
            >
              <PolicyAccordionsBlock
                :sections="sections"
                :loading="loading"
                :error="error"
                :open-section="openSection"
                @toggle="toggleSection"
              />
            </div>
          </div>
        </section>
      </div>
    </main>
  </ContentWrapper>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ContentWrapper from '../components/Layouts/ContentWrapper.vue'
import PolicyAccordionsBlock from '../components/Policy/PolicyAccordionsBlock.vue'

const sections = ref([])
const openSection = ref(null)
const loading = ref(true)
const error = ref(null)

onMounted(async () => {
  try {
    const response = await fetch('/privacy-policy.json')
    if (!response.ok) throw new Error('Failed to load privacy policy')
    sections.value = await response.json()
  } catch (e) {
    error.value = e.message
  } finally {
    loading.value = false
  }
})

function toggleSection(id) {
  openSection.value = openSection.value === id ? null : id
}
</script>
